import React, { useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";

import DownloadButton from "../../../../../components/buttons/download-button/DownloadButton";
import { ReportTemplatesStorage } from "../../../../../services/organization/ReportTemplatesStorage";
import useModal from "../../../../../components/dialog/useModal";
import { Dialog } from "../../../../../components/dialog/Dialog";
import { Dropdown, DropdownOption } from "../../../../../components/dropdown/Dropdown";
import "./composition.scss";

interface IDownloadButtonProps {
  reportTemplatesStorage: ReportTemplatesStorage;
}

export const DownloadDefaultReportTemplateButton = observer((props: IDownloadButtonProps) => {
  const { reportTemplatesStorage } = props;
  const { toggleModal, isVisible } = useModal();
  const [selectedFormat, setSelectedFormat] = useState<DropdownOption>();

  const getFormatOptions: () => DropdownOption[] = useCallback(() => (
    [...toJS(reportTemplatesStorage.projectFormats).map((f) => ({ id: f.id, name: f.name }))]
  ), [reportTemplatesStorage.projectFormats]);

  const closeModal = useCallback(() => {
    toggleModal();
    setSelectedFormat(undefined);
  }, [toggleModal]);

  const handleDownloadDefaultClick = useCallback(() => {
    reportTemplatesStorage.downloadDefaultTemplate(selectedFormat?.id as string);
    closeModal();
  }, [closeModal, reportTemplatesStorage, selectedFormat?.id]);

  return (
    <>
      <DownloadButton labelKey="ReportTemplates.download-default" onClick={toggleModal} />
      <Dialog
        isVisible={isVisible}
        sidePosition
        onHide={closeModal}
        titleKey="ReportTemplates.download-modal-title"
        subTextKey="ReportTemplates.download-modal-select-format"
        buttonOk={{
          textKey: "general.download",
          action: handleDownloadDefaultClick,
          disabled: selectedFormat === undefined,
        }}
        buttonCancel={{
          textKey: "general.cancel",
          action: closeModal,
        }}
      >
        <div className="template-dropdown-container">
          <Dropdown
            selectedOption={selectedFormat ?? null}
            options={getFormatOptions()}
            onChange={(newFormat) => setSelectedFormat(newFormat)}
            placeholderKey="ReportTemplates.download-modal-dropdown.placeholder"
          />
        </div>
      </Dialog>
    </>
  );
});
